module.exports = __webpack_public_path__ + "static/media/members.d929d3e0.svg";